import React from 'react'
import FlexContainer from 'core-system/FlexContainer'
import Text from 'core-system/Text'
import Radio from 'core-system/Radio'
import QTFUtils from 'features/QTF/Shared/QTFUtils'

interface PayrollScheduleProps {
  payrollSchedule: 'BI_WEEKLY' | 'BI_MONTHLY' | 'MONTHLY'
  onPayrollScheduleChange: (
    payrollSchedule: 'BI_WEEKLY' | 'BI_MONTHLY' | 'MONTHLY'
  ) => void
}

const PayrollSchedule = ({
  payrollSchedule,
  onPayrollScheduleChange,
}: PayrollScheduleProps) => {
  return (
    <>
      <FlexContainer alignItems='center' justifyContent='space-between'>
        <FlexContainer alignItems='center' justifyContent='space-between'>
          <Radio
            id='radioContainer'
            active={payrollSchedule === 'BI_WEEKLY'}
            onClick={() => onPayrollScheduleChange('BI_WEEKLY')}
          />
          <Text variant='body1' marginLeft={'0.5rem'} marginTop={'0.0625rem'}>
            {QTFUtils.payrollScheduleOptions['BI_WEEKLY']}
          </Text>
        </FlexContainer>
        <FlexContainer alignItems='center' justifyContent='space-between'>
          <Radio
            id='radioContainer'
            active={payrollSchedule === 'BI_MONTHLY'}
            onClick={() => onPayrollScheduleChange('BI_MONTHLY')}
          />
          <Text variant='body1' marginLeft={'0.5rem'} marginTop={'0.0625rem'}>
            {QTFUtils.payrollScheduleOptions['BI_MONTHLY']}
          </Text>
        </FlexContainer>
        <FlexContainer alignItems='center' justifyContent='space-between'>
          <Radio
            id='radioContainer'
            active={payrollSchedule === 'MONTHLY'}
            onClick={() => onPayrollScheduleChange('MONTHLY')}
          />
          <Text variant='body1' marginLeft={'0.5rem'} marginTop={'0.0625rem'}>
            {QTFUtils.payrollScheduleOptions['MONTHLY']}
          </Text>
        </FlexContainer>
      </FlexContainer>
    </>
  )
}

export default React.memo(PayrollSchedule)
